import { createContext, useContext } from 'react';

export const PageContext = createContext({});

export function usePageContext() {
    return useContext(PageContext);
}

export function usePageId() {
    return usePageContext().id;
}

export function usePageSize() {
    return usePageContext().size;
}
